import Skeleton from 'react-loading-skeleton'
import { Header } from '../../components/Header'
import { IntakeItemSkeleton } from '../../components/Intake/IntakeItemSkeleton'
import { StyledButton } from '../../elements/Button'

export const IntakeSkeleton = () => {
  return (
    <>
      <Header title="">
        <h1>
          <Skeleton height="45px" />
        </h1>
      </Header>

      <IntakeItemSkeleton type="detailed" />

      <div className="button-section">
        <StyledButton>
          <Skeleton
            height="37px"
            width="400px"
            style={{ marginBottom: '30px' }}
          />
          <Skeleton
            height="50px"
            width="250px"
            style={{ margin: '10px auto' }}
          />
        </StyledButton>
      </div>
    </>
  )
}
